import { TerminalItemDto } from "./TerminalInfoDto";

export interface IUserDetailsDto {
    contractCode: string | undefined;
    email: string;
    name: string;
    surname: string;
    username: string;
    terminalInfo: TerminalItemDto[] | null;
    creation: string;
    userType: string | null;
    description: string | null;
}

export class UserDetails implements IUserDetailsDto {
    public contractCode: string | undefined;
    public email: string;
    public name: string;
    public surname: string;
    public username: string;
    public terminalInfo: TerminalItemDto[] | null;
    public creation: string;
    public userType: string | null;
    public description: string | null;

    constructor(contractCode: string | undefined, email: string, name: string, surname: string, username: string, terminalInfo: TerminalItemDto[] | null,
        creation: string, userType: string | null, description: string | null){
            this.contractCode = contractCode;
            this.email = email;
            this.name = name;
            this.surname = surname;
            this.userType = userType;
            this.username = username;
            this.terminalInfo = terminalInfo;
            this.creation = creation;
            this.description = description;
        }
}